import React from 'react'
import "./Third.css"
import myImage1 from '../../images/jupor3.webp'
import myImage2 from '../../images/jupor4.webp'
import myImage3 from '../../images/jupor5.webp'
import myImage4 from '../../images/jupor6.webp'
function Third() {
  return (
    <div style={{backgroundColor:"rgb(22, 22, 22)"}}>
      <div className='container hc1'>
          <h2>Products</h2>
          <hr style={{width:"93%"}}/>
      </div>
      <div className='container hc2'>
        <div className='row text-center' style={{display:"flex", justifyContent:"center", alignContent:"center", margin:"2rem"}}>
              <div class="card col-lg-6 hc3" style={{width:"24rem",backgroundColor:"rgb(22, 22, 22)", margin:"1rem", border:"none"}}>
                <img class="card-img-top" style={{borderRadius:"100%"}} src={myImage1} alt="Card image cap"/>
                <div class="card-body">
                  <h5 class="card-title">Experience You Can Count On</h5>
                  <p class="card-text">We, with Business Blvd Inc. have propelled a stunning open door which encourages you as a small business owner to develop and showcase your business globally.</p>
                  <button className='button' style={{padding:"2px",  border: "1px solid white"}}><p className='btn-txt'><a className='hc4' style={{textDecoration:"unset"}} href='https://businessblvd.ca'>Visit Website</a></p></button>
                </div>
              </div>
              <div class="card col-lg-6 hc3" style={{width:"24rem",backgroundColor:"rgb(22, 22, 22)", margin:"1rem", border:"none"}}>
                <img class="card-img-top" style={{borderRadius:"100%"}} src={myImage2} alt="Card image cap"/>
                <div class="card-body">
                  <h5 class="card-title">Jupor Consultants</h5>
                  <p class="card-text">We have opened a magnificent door that enables you, as a small business owner, to expand and market your company internationally.</p>
                  <button className='button' style={{padding:"2px",  border: "1px solid white"}}><p className='btn-txt'><a className='hc4' style={{textDecoration:"unset"}} href='/'>Visit Website</a></p></button>
                </div>
              </div>
        </div>

        <div className='row text-center' style={{display:"flex", justifyContent:"center", alignContent:"center"}}>
              <div class="card col-lg-6 hc3" style={{width:"24rem",backgroundColor:"rgb(22, 22, 22)", margin:"1rem", border:"none"}}>
                <img class="card-img-top" style={{borderRadius:"100%"}} src= {myImage3} alt="Card image cap"/>
                <div class="card-body">
                  <h5 class="card-title">Enrolme Education</h5>
                  <p class="card-text">With the help of our online application platform, Enrolme makes it possible for every student who wants to study abroad to enroll in the college or institution of their choice. We link students from the Philippines, Bangladesh, Sri Lanka, Nepal, India, Pakistan, and Nepal to Colleges and Universities all around the world.</p>
                  <button className='button' style={{padding:"2px",  border: "1px solid white"}}><p className='btn-txt'><a className='hc4' style={{textDecoration:"unset"}} href='https://enrolme.io'>Visit Website</a></p></button>
                </div>
              </div>
              <div class="card col-lg-6 hc3" style={{width:"24rem",backgroundColor:"rgb(22, 22, 22)", margin:"1rem", border:"none"}}>
                <img class="card-img-top" style={{borderRadius:"100%"}} src={myImage4} alt="Card image cap"/>
                <div class="card-body">
                  <h5 class="card-title">Workly</h5>
                  <p class="card-text"> Workly is empowering better coordinated care delivery for Canadians and their families by connecting motivated individuals in the healthcare field to medical organizations across Canada.  </p>
                  <button className='button' style={{padding:"2px",  border: "1px solid white"}}><p className='btn-txt'><a className='hc4' style={{textDecoration:"unset"}} href='https://theworkly.co'>Visit Website</a></p></button>
                </div>
              </div>
        </div>
          
      </div>
    </div>
  )
}

export default Third
